import { iframeAppBiLoggerFactory } from '@wix/iframe-app-bi-logger';
import store from '../../store';

let logger;
const Wix = window.Wix;

const reportSendService = (sendService) => logger.log(sendService);

const initLogger = () => {
  const { isBusinessApp } = store.getState().appReducer;
  logger = iframeAppBiLoggerFactory(window.Wix, {
    endpoint: 'wixlabs-users',
  })
    .setEvents({})
    .updateDefaults({
      src: 63,
      comp_id: Wix.Utils.getOrigCompId(),
      hosting: 'wixlabs-users',
      type: isBusinessApp ? 'business' : 'personal',
    })
    .logger();
};
initLogger();

/**
 * @param {*object} data
 * @description Trigger event to wix Bi.
 * @returns {*void}
 */
export default function triggerEvent(data) {
  reportSendService(data);
}
